export const mapWidgetConstants = {
    NEW_MAP_WIDGET: 'NEW_MAP_WIDGET',
    UPDATE_MAP_WIDGET: 'UPDATE_MAP_WIDGET',
    DELETE_MAP_WIDGET: 'DELETE_MAP_WIDGET'
};

export default mapWidgetConstants;